import AddMember from './AddMemberModal';

export default AddMember;
